module.exports = __webpack_public_path__ + "media/images/trust-icon-database-e794cf4578b74948f7c3241794cebdf4.svg";